<template>
  <div class="calico-search-dialog-page">
    <h2>Dialog Test Page</h2>
    <button @click="show = true">
      Open Dialog
    </button>
    <SearchDialog
      v-if="show"
      @close="show = false"
    />
  </div>
</template>
  
  <script>
  import SearchDialog from "@/components/pattern/searchDialog/index.vue";
  
  export default {
    name: "CalicoSearchDialogPage",
    components: {
      SearchDialog,
    },
    data() {
      return {
        recentSearches: [
        { businessName: 'Business 1', state: 'CA', zip: '12345' },
        { businessName: 'Business 2', state: 'NY', zip: '54321' },
        { businessName: 'Business 3', state: 'TX', zip: '67890' }
      ],
      show: false
      };
    },
  };
  </script>
  
  <style scoped lang="scss">
  .calico-search-dialog-page {
    padding: $space-large
  }
  </style>